/**
 * Powstaje to tylko dlatego, że gdzie niegdzie jest wprost 
 * zależność od ihestiaCommonDirectives.istevenMultiSelectMerged
 */
angular.module('ihestiaCommonDirectives.istevenMultiSelectMerged', [
    'lsnBase.istevenMultiSelectMerged'
  ]);